import React from 'react'
import { Helmet } from 'react-helmet'
import { ROUTES } from '../../lib/constants'
import styles from './LegalPages.module.scss'

export const TextMessagingTerms = (): React.JSX.Element => {
  return (
    <>
      <Helmet>
        <title>{ROUTES.textMessagingTerms.title}</title>
      </Helmet>

      <div className="grid-12">
        <div className={styles.container}>
          <h1>Text Messaging Terms and Conditions</h1>

          <section className={styles.content}>
            <p className="italic">Last Updated: October 2026</p>
            <p>
              Cityside Networks, LLC dba Cityside Fiber ("Cityside") and third
              parties acting on its behalf may contact you by phone call, text
              message, or email using any telephone number or email address you
              provide Cityside. We use these communications for purposes related
              to your account and Services, such as billing and payment
              collection, appointment scheduling and reminders, service alerts
              and outages, account security, network issues, and fraud
              prevention. By providing us with your contact information, you
              consent to receive these communications and agree that they are
              not unsolicited. Calls and texts may be made using an automatic
              telephone dialing system and/or artificial or prerecorded
              messages.
            </p>
            <p>
              You can stop text messages at any time by replying STOP to any
              text from Cityside. Reply HELP for assistance. To change or opt
              out of calls and emails, visit our customer portal, which is the
              only way to manage those communications. Some account-related
              messages cannot be turned off, including notices about
              emergencies, suspected fraud, breaches of your service terms or
              applicable law, security concerns, and threats to our network.
            </p>
            <p>
              We do not sell your text message data or share it with third
              parties to use for their own purposes. We may disclose it to
              vendors that provide services to Cityside, or when required by
              law. How often you receive messages depends on your Service
              activity, frequency may vary. Message and data rates may apply.
            </p>
          </section>
        </div>
      </div>
    </>
  )
}
